var _linearGradient, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 25 25",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "3d7e740b-f100-4511-9481-347b5842fcc2",
    gradientUnits: "userSpaceOnUse",
    x1: 1.97,
    x2: 23,
    y1: 12.5,
    y2: 12.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#4d148b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#a8196f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#d81b60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#ff6f00"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m18 15.5v6a1.47 1.47 0 0 1 -1.41 1.5h-13.18a1.47 1.47 0 0 1 -1.41-1.5v-18a1.47 1.47 0 0 1 1.41-1.5h13.18a1.47 1.47 0 0 1 1.41 1.5v6a.5.5 0 0 1 -1 0v-6a.47.47 0 0 0 -.44-.5h-13.15a.47.47 0 0 0 -.41.5v18a.47.47 0 0 0 .44.5h13.15a.47.47 0 0 0 .44-.5v-6a.5.5 0 0 1 1 0zm5-2.81a.5.5 0 0 0 0-.38.36.36 0 0 0 -.11-.16l-2-2a.49.49 0 0 0 -.7.7l1.1 1.15h-8.79a.5.5 0 0 0 0 1h8.79l-1.14 1.15a.48.48 0 0 0 0 .7.48.48 0 0 0 .7 0l2-2a.36.36 0 0 0 .15-.16z",
    fill: "url(#3d7e740b-f100-4511-9481-347b5842fcc2)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutDark);
export default __webpack_public_path__ + "static/media/LogoutDark.e6625e44.svg";
export { ForwardRef as ReactComponent };